<template>
  <component :is="supplierData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="supplierData === undefined">
      <h4 class="alert-heading">獲取財務公司數據時出錯</h4>
      <div class="alert-body">
        找不到相關財務公司。請查看
        <b-link class="alert-link" :to="{ name: 'suppliers-list' }"> 財務公司名單 </b-link>
      </div>
    </b-alert>
    <supplier-edit-tab-information v-if="supplierData"
      :supplier-data="supplierData"
      @refetch-data="refetchData"
      class="p-sm-2"
    />
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab  } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import supplierStoreModule from "../supplierStoreModule";
import SupplierEditTabInformation from "./SupplierEditTabInformation.vue";


export default {
  components: {
    SupplierEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const supplierData = ref({id:"0"});

    const SUPPLIER_APP_STORE_MODULE_NAME = "app-supplier";
    
    const supplier = {id:0,is_active :1,childs:[], company_bit: 0};


    if (!store.hasModule(SUPPLIER_APP_STORE_MODULE_NAME))
      store.registerModule(SUPPLIER_APP_STORE_MODULE_NAME, supplierStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SUPPLIER_APP_STORE_MODULE_NAME))
        store.unregisterModule(SUPPLIER_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "suppliers-create") {
        supplierData.value = supplier;
      } else {
        store
          .dispatch("app-supplier/fetchSupplier", { id: router.currentRoute.params.id })
          .then((response) => {
            supplierData.value = response.data.supplier;
          })
          .catch((error) => {
            console.log("error when fetching supplier", error);
            if (error.response.status === 404) {
              supplierData.value = undefined;
            }
          });
      }
    };

    onMounted(() => {
      refetchData();
    });

    const adminStatusOptions = ref([]);
    const loanStatusOptions = ref([]);



    return {
      supplierData,
      refetchData
    };
  },
};
</script>
